module.exports = __webpack_public_path__ + "525ca447543f5865d928ddeef0f0b2dc.png";